import { memo } from "react";

import { AppLoader } from "@/common/components";
import { useAppSelector } from "@/common/hooks";

const HouseViewIsLoading = memo(() => {
  const isLoading = useAppSelector((state) => state.houseView.pageData.isDataLoading);
  return <AppLoader fullScreen open={isLoading} />;
});

export const __HouseViewIsLoading = HouseViewIsLoading;
